// The workspace's tabs (pages/MainPage.js draws them; reacttour/StartTour.js knows their ids for phones).
export const TABS = [
  { key: "dashboard", label: "Dashboard" },
  { key: "studio", label: "Studio" },
  { key: "items", label: "Item library" },
  { key: "audit", label: "Audit" },
  { key: "settings", label: "Settings" },
];
